"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonAccordionRow = void 0;
const React = require("react");
const BronsonAccordionRow = (props) => {
    const [visibility, setVisibility] = React.useState(props.isOpen);
    React.useEffect(() => {
        setVisibility(props.isOpen);
    }, [props.isOpen]);
    const renderTitle = () => {
        if (props.title) {
            return props.title;
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderSubtitle = () => {
        if (props.subtitle) {
            return React.createElement("p", { className: 'c-accordion__subtitle' }, props.subtitle);
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderContent = () => {
        if (props.content) {
            return React.createElement(React.Fragment, null, props.content);
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const handleClick = (event) => {
        event.preventDefault();
        setVisibility(!visibility);
        if (props.onToggle) {
            props.onToggle(+props.keyIdentifier);
        }
    };
    return (React.createElement(React.Fragment, { key: props.keyIdentifier },
        React.createElement("div", { className: 'c-accordion__header', key: props.keyIdentifier, onClick: handleClick },
            React.createElement("span", { className: 'c-accordion__title-icon' }),
            React.createElement("h3", { className: 'c-accordion__title' },
                React.createElement("button", { className: 'c-accordion__title-label', "aria-expanded": 'false', type: 'button' },
                    React.createElement("span", { className: 'c-accordion__title-label-text  ' }, renderTitle()))),
            renderSubtitle()),
        React.createElement("div", { className: 'c-accordion__panel', "aria-hidden": !visibility },
            React.createElement("div", { className: 'c-accordion__content' }, renderContent()))));
};
exports.BronsonAccordionRow = BronsonAccordionRow;
